export default __webpack_public_path__ + "static/media/auth-img.6a2dc36f.png";